(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["msw-wish-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__mswWdInit) return;
    window.__mswWdInit = true;

    // stale = the DOM rows no longer match the list -> refetch on next open.
    let stale = true;

    const dlg = () => document.querySelector('[data-msw-wish-drawer]');

    const chrome = (root) => {
      const n = window.MSWWish ? window.MSWWish.count() : 0;
      const list = root.querySelector('[data-msw-wd-list]');
      const empty = root.querySelector('[data-msw-wd-empty]');
      const share = root.querySelector('[data-msw-wd-share]');
      if (list) list.hidden = n === 0;
      if (empty) empty.hidden = n !== 0;
      if (share) share.hidden = n === 0;
    };

    const renderRows = (root) => {
      const list = root.querySelector('[data-msw-wd-list]');
      if (!list || !window.MSWWish) return;
      stale = false;
      const handles = window.MSWWish.list().slice().reverse(); // newest first
      list.innerHTML = '';
      chrome(root);
      if (!handles.length) return;

      const items = handles.map((handle) => {
        const el = document.createElement('div');
        el.className = 'msw-wd__item msw-wd__item--loading';
        el.setAttribute('data-msw-wd-item', handle);
        list.appendChild(el);
        return el;
      });

      const pruned = [];
      Promise.allSettled(handles.map((handle, i) =>
        fetch('/products/' + encodeURIComponent(handle) + '?section_id=msw-wish-row')
          .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            // Stylesheet subsetting: a Section API response carries the section's CSS in
            // <style data-section-stylesheet>; we inject only the inner node, so adopt it once.
            const css = doc.querySelector('style[data-section-stylesheet]');
            if (css && ![...document.querySelectorAll('style[data-section-stylesheet]')].some((s) => s.textContent === css.textContent)) {
              document.head.appendChild(css);
            }
            const inner = doc.querySelector('[data-msw-wish-row-inner]');
            if (!inner) throw new Error('no row');
            items[i].innerHTML = inner.innerHTML;
            items[i].classList.remove('msw-wd__item--loading');
          })
          .catch((reason) => {
            // Prune ONLY on a real 404 (product removed). Network/429/5xx/parse:
            // drop the row but keep the handle.
            items[i].remove();
            if (reason === 404) pruned.push(handle);
          })
      )).then(() => {
        pruned.forEach((h) => { if (window.MSWWish.has(h)) window.MSWWish.toggle(h); });
        chrome(root);
      });
    };

    const open = () => {
      const root = dlg();
      if (!root) return;
      if (!root.open) root.showModal();
      if (stale) renderRows(root);
      else chrome(root);
    };

    window.MSWWishDrawer = { open };

    document.addEventListener('click', (event) => {
      const t = event.target;
      if (!t || !t.closest) return;
      const root = dlg();
      if (!root) return;

      if (t.closest('[data-msw-wd-close]')) {
        root.close();
        return;
      }

      // light-dismiss fallback for browsers without closedby: backdrop click has
      // target === <dialog> (the inner column fills the whole panel)
      if (t === root && root.open) {
        root.close();
        return;
      }

      const share = t.closest('[data-msw-wd-share]');
      if (share && window.MSWWish) {
        const base = share.getAttribute('data-share-base') || '/';
        const url = location.origin + base + '?list=' + window.MSWWish.list().join(',');
        if (navigator.share) {
          navigator.share({ url }).catch(() => { /* user dismissed */ });
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(() => {
            if (share.__mswCopied) return;
            share.__mswCopied = true;
            const original = share.textContent;
            share.textContent = share.getAttribute('data-copied-label') || original;
            setTimeout(() => {
              share.textContent = original;
              share.__mswCopied = false;
            }, 2000);
          }).catch(() => { /* clipboard blocked */ });
        }
      }
    });

    document.addEventListener('msw-wish:change', () => {
      const root = dlg();
      if (!root || !window.MSWWish) return;
      // de-wished rows leave immediately (works open or closed)
      root.querySelectorAll('[data-msw-wd-item]').forEach((el) => {
        if (!window.MSWWish.has(el.getAttribute('data-msw-wd-item'))) el.remove();
      });
      // any handle without a row (added since last render) -> refetch on next open
      const have = {};
      root.querySelectorAll('[data-msw-wd-item]').forEach((el) => {
        have[el.getAttribute('data-msw-wd-item')] = true;
      });
      if (window.MSWWish.list().some((h) => !have[h])) stale = true;
      chrome(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
